import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

/**
 * Renders datepicker values as MM/DD/YYYY, the app-wide display format.
 */
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override format(date: Date, _displayFormat: string): string {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
}

export const APP_DATE_FORMATS = {
  parse: { dateInput: "MM/DD/YYYY" },
  display: {
    dateInput: "MM/DD/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
